<template>
  <div>
    <a @click="modal3=true">编辑{{type}}</a>
    <Modal :title="'编辑'+type"  width="800" v-model="modal3" @on-ok="save">
      <Button type="primary" @click="modal4=true">+增加章节</Button>
      <br/>
      <br/>
      <List header="Header" border  v-for="(item,index) in detail" style="margin-bottom: 12px">
        <div slot="header" >
          <b>
            <Input style="width: 70%" v-model="item.name"/>
            &nbsp;<a @click="detail.splice(index,1)">删除章节</a>
          </b>
        </div>
        <ListItem  v-for="(i,k) in item.nodes" style="text-align: right">
          <Input v-model="i.name" size="small" style="width: 80%"/>
          &nbsp;<a @click="item.nodes.splice(k,1)">删除</a>
          <cite>|</cite>
          <a @click="item.nodes.push({name:'新增节点',nodes:[]})">增加</a>

          <span v-if="type==='课程大纲'">
             <cite>|</cite>
              <a @click="i.nodes.push({name:'新增下级节点',nodes:[]})">增加下级</a>
          </span>


          <div v-if="i.nodes">
            <span  v-for="(n,w) in i.nodes">
              <Input v-model="n.name" size="small" style="width: 80%"/>
              <a @click="i.nodes.splice(w,1)">删除</a>
            </span>
          </div>

        </ListItem>
      </List>

    </Modal>
    <Modal title="增加章节"  width="600" v-model="modal4"  @on-ok="save4">
      <Form :label-width="100">
        <FormItem label="章节名称" required>
          <Input v-model="d2.name"/>
        </FormItem>

        <FormItem label="章节内容" required>
          <Input v-model="d2.note" type="textarea" :autosize="{minRows: 5,maxRows: 15}" placeholder=""/>
        </FormItem>

      </Form>
    </Modal>
  </div>
</template>


<script>
  export default {
    props:{
      detail:{
        type:Array,
        default:[]
      },
      type:{
        type:String,
        default:''
      },
      value:{
        type:String,
        default:''
      },
    },
    data(){
      return{
        modal3:false,
        //增加章节
        modal4:false,
        d2:{
          name:'',
          note:''
        }
      }
    },
    methods:{
      save(){
        this.value = JSON.stringify(this.detail);
        this.detail = null;

        this.$emit('input',this.value);
        this.$emit('on-change');
      },
      save4(){

        console.log(this.detail);

        let d = {
          name:this.d2.name,
          nodes:[],
          descption:''
        };
        let ar = this.d2.note.split('\n');
        for(let i = 0;i<ar.length;i++){
          if(ar[i]){
            d.nodes.push({name:ar[i],descption:null,nodes:[]});
          }
        }
        this.detail.push(d);
        this.d2 = {
          name:'',
          note:''
        };
      },
    }

  }

</script>



// WEBPACK FOOTER //
// src/components/common/json/JsonEdit.vue